// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"66":"zh-translations","852":"th-translations","866":"en-PSEUDO-translations","877":"id-translations","943":"en-translations"}[chunkId] + "-" + {"66":"f7bdf3f1ced6cef0d2a4","852":"3758cf47bf35f5ef7943","866":"500d88a56e398afaa01a","877":"90d5e30be7d6ee7a97ec","943":"3a508fa77dd0617e23e8"}[chunkId] + ".js";
};